import ArrangeTheWords from './ArrangeTheWords';

export default ArrangeTheWords;